import React from "react";
// @ts-ignore
import NavBar from "../../screens/SatCourse/CoursesScreen";
// @ts-ignore
import MockTestBanner from "../../components/SatCourse/MockTestBanner";
// @ts-ignore
import Frame from "../../Assets/Images/Sat-images/Frame.webp";
// @ts-ignore
import QuestionFram from "../../Assets/Images/Sat-images/Vector-img.webp";
import { TbMathGreater } from "react-icons/tb";
import { TiTick } from "react-icons/ti";
import { FiLock } from "react-icons/fi";

export interface MockInfoItem {
  title: string;
  minutes: string;
  questions: string;
  isCompleted: boolean;
}

export interface MockInfoProps {
  isLoading?: boolean;
  isError?: boolean;
  Error?: string;
  data: MockInfoItem[];
  HandleId: (title: string) => void;
}

const MockInfo: React.FC<MockInfoProps> = (props) => {
  return (
    <>
      {props.isLoading ? (
        <h1>LOADING.........</h1>
      ) : (
        <div className="Home-Container">
          {props.isError ? (
            <h1>{props.Error}</h1>
          ) : (
            <div className="home-sub-container">
              <div>
                <NavBar />
              </div>
              <div className="main-right-container">
                <div>
                  <MockTestBanner title={"Mock Test"} nolesson={"12"} />{" "}
                </div>
                <div className="mock-info-second-section ">
                  <div className="mock-info-right-list">
                    {props.data?.length > 0 &&
                      props.data.map((item: MockInfoItem, index: number) => {
                        return (
                          <div
                            key={index}
                            className={
                              item.isCompleted
                                ? "list-item-container"
                                : "list-item-container disable-div"
                            }
                            onClick={() => {
                              props.HandleId(item.title);
                            }}
                          >
                            <div className="mock-icon-main-panel">
                              <div
                                className={
                                  item.isCompleted === true
                                    ? "info-icon-div"
                                    : "info-icon-div course-uncomplete"
                                }
                              >
                                <TiTick size="25px" fill="white" />
                              </div>
                              <div className="mock-info-line-div"></div>
                            </div>
                            <div className="mock-flex-mid-main-conatiner">
                              <div className="mid-left-sub-container">
                                <div className="mock-reading-div">
                                  {item.title}
                                </div>
                                <div
                                  className={
                                    item.isCompleted
                                      ? "hide-section"
                                      : "mock-unlock-panel"
                                  }
                                >
                                  <div>
                                    <FiLock size="10px" color="#A20107" />
                                  </div>
                                  <div className="mock-unlock-heading">
                                    complete previous section to unlock
                                  </div>
                                </div>
                                <div className="mock-info-right-question-panel">
                                  <div className="mock-minutes">
                                    <div>
                                      <img
                                        src={Frame}
                                        width="15px"
                                        height="15px"
                                        alt="clock"
                                      />
                                    </div>
                                    <div>
                                      <p className="mock-haed">
                                        {item.minutes}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="mock-question">
                                    <img
                                      src={QuestionFram}
                                      width="15px"
                                      height="15px"
                                      alt="question"
                                    />
                                    <p className="mock-haed">
                                      {item.questions}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="math-icon">
                                <TbMathGreater size="15px" />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default React.memo(MockInfo);
